"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.dotPathFromAncestry = dotPathFromAncestry;
exports.dotPathFromAncestors = dotPathFromAncestors;
exports.getItemFromPath = getItemFromPath;
exports.setParents = setParents;
exports.isDefined = isDefined;
exports.isEmptyObj = isEmptyObj;
exports.formRootName = exports.invalidParents = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _dotPropImmutable = require("dot-prop-immutable");

function dotPathFromAncestry(ancestryPath) {
  return dotPathFromAncestors(ancestryPath.split('.'));
}

function dotPathFromAncestors(ancestors) {
  if (ancestors[0] === formRootName) {
    (0, _splice.default)(ancestors).call(ancestors, 0, 1);
  }

  return (0, _map.default)(ancestors).call(ancestors, function (ancestor) {
    return ancestor === 'parent' ? ancestor : "options.items.".concat(ancestor);
  }).join('.');
}

function getItemFromPath(itemInfo, ancestors) {
  return (0, _dotPropImmutable.get)(itemInfo, typeof ancestors === 'string' ? dotPathFromAncestry(ancestors) : dotPathFromAncestors(ancestors));
}

var invalidParents = {
  invalid: false
};
exports.invalidParents = invalidParents;

function setParents(formInfo) {
  invalidParents.invalid = false;
  if (!formInfo.parent) formInfo.root = formInfo;
  var items = (0, _isArray.default)(formInfo.options.items) ? formInfo.options.items : (0, _values.default)(formInfo.options.items);

  var _iterator = (0, _createForOfIteratorHelper2.default)(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      item.parent = formInfo;
      item.root = formInfo.parent ? formInfo.root : formInfo;

      if (item.type === 'form' || item.type === 'variable-form') {
        setParents(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var formRootName = '__formroot__';
exports.formRootName = formRootName;

function isDefined(val) {
  return !(val === null || val === undefined);
}

function isEmptyObj() {
  var _context;

  var rowVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _filter.default)(_context = (0, _entries.default)(rowVal)).call(_context, function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        childVal = _ref2[1];

    return isDefined(childVal);
  }).length === 0;
}
